import React, { useEffect, useState, useMemo, useCallback } from 'react';
import { Spin } from 'antd';
import _ from 'lodash';
import { useParams, useHistory } from 'react-router-dom';

import { PaymentPlan } from 'api/types/owner';
import { useOwnerDetails } from 'api/owners';
import { Tabs } from 'ui-kit';
import Wrapper from 'components/Wrapper';
import OverviewLayout from 'components/OverviewLayout/OverviewLayout';

import AccountNotificationForm from 'components/Account/AccountNotificationForm';
import StoreDetailsForm from 'components/Account/StoreDetailsForm';
import SignInSettingsForm from 'components/Account/SignInSettingsForm';
import PersonalDetailsForm from 'components/Account/PersonalDetailsForm';
import CoHostWrapper from 'components/CoHosts';
import { EProfileTab } from 'components/TopNav/constants';
import { reverse } from 'utils/urls';
import { URLS } from 'components/Routes/urls';
import { useSignedUser } from 'api/auth';

import './Settings.scss';

const SettingsAccountPage = () => {
  const history = useHistory();
  const { tab } = useParams();

  const [accountDetails, setAccountDetails] = useState({});
  const { data: user } = useSignedUser();
  const { data, isLoading } = useOwnerDetails(user?.owner_id);
  const [isCoHostsDisabled, setIsCoHostsDisabled] = useState(false);

  useEffect(() => {
    if (data.actor) {
      setAccountDetails({
        firstName: data.actor.firstName,
        lastName: data.actor.lastName,
        email: data.user.email,
        phone: data?.phone,
      });
    }
  }, [isLoading]);

  // TODO: this should be removed when the error can get from the BE
  useEffect(
    () => setIsCoHostsDisabled(_.includes([PaymentPlan.Basic, PaymentPlan.Pro], data.plan)),
    [data],
  );

  const accountTabs = useMemo(() => {
    let tabs = [];
    if (user.is_cohost) {
      tabs = [
        {
          key: EProfileTab.STORE_DETAILS,
          label: 'Store details',
          forceRender: true,
        },
        {
          key: EProfileTab.CO_HOSTS,
          label: 'Co-Hosts',
        },
      ];
    } else {
      tabs = [
        {
          key: EProfileTab.PERSONAL_DETAILS,
          label: 'Personal Details',
          forceRender: true,
        },
        {
          key: EProfileTab.NOTIFICATIONS,
          label: 'Notifications',
        },
        {
          key: EProfileTab.STORE_DETAILS,
          label: 'Store details',
        },
        {
          key: EProfileTab.SIGN_IN_SETTINGS,
          label: 'Sign-In Settings',
        },
        {
          key: EProfileTab.CO_HOSTS,
          label: 'Co-Hosts',
        },
      ];
    }

    return tabs;
  }, [user]);

  const handleChangeTab = useCallback(
    (key) => history.push(reverse({ url: URLS.ACCOUNT, params: { tab: key } })),
    [],
  );

  return (
    <OverviewLayout>
      <Wrapper className="hc-settings" title="My Account">
        <Spin spinning={isLoading}>
          <Tabs onChange={handleChangeTab} activeKey={tab}>
            {accountTabs.map(({ key, label }) => {
              return (
                <Tabs.TabPane tab={label} key={key}>
                  {key === EProfileTab.PERSONAL_DETAILS && !isLoading && accountDetails.email ? (
                    <PersonalDetailsForm ownerId={user.owner_id} initialData={accountDetails} />
                  ) : null}
                  {key === EProfileTab.NOTIFICATIONS ? (
                    <AccountNotificationForm ownerPlan={data.plan} />
                  ) : null}

                  {key === EProfileTab.STORE_DETAILS ? (
                    <StoreDetailsForm
                      ownerId={user.owner_id}
                      initialIsLocalProductsDisabled={data.isLocalProductOptedOut}
                    />
                  ) : null}

                  {key === EProfileTab.SIGN_IN_SETTINGS ? (
                    <SignInSettingsForm ownerId={user.owner_id} />
                  ) : null}
                  {key === EProfileTab.CO_HOSTS ? (
                    <CoHostWrapper isDisabled={isCoHostsDisabled} />
                  ) : null}
                </Tabs.TabPane>
              );
            })}
          </Tabs>
        </Spin>
      </Wrapper>
    </OverviewLayout>
  );
};

export default SettingsAccountPage;
